module.exports = __webpack_public_path__ + "static/media/infraestrutura.35ce19a0.svg";